function PaymentMethodChannelItem({
                                      name,
                                      index,
                                      logo_url,
                                      setSlidesWidth,
                                      slidesWidth,
                                      slidesCount,
                                      setSlidesCount,
                                      slidesIndex,
                                      setSlidesIndex
                                  }) {

    function onLoad({target: img}) {
        if (slidesIndex.indexOf(index) === -1) {
            setSlidesIndex([...slidesIndex, index]);
            setSlidesCount(slidesCount + 1);
            setSlidesWidth(slidesWidth + img.offsetWidth + 20);
        }
    }

    return (
        <div className="slider-item">
            <img loading="lazy" src={logo_url} alt={name} onLoad={onLoad}/>
        </div>
    );
}

export default PaymentMethodChannelItem;
